import React, { useState, ReactElement } from 'react';
import { IMedia } from '../../../common/types';
import { FontItem, FontNameContainer, PopoverContainer, Divider } from './styled';
import { Typography } from '@unfold/typography';

import Popover, { ArrowContainer } from 'react-tiny-popover';
import { Button } from '@unfold/button';
import { OptionsMenuIcon } from '@unfold/icon';
import { Input } from '@unfold/input';
import { useBrandKitState } from '../../../store';

interface IFontProps {
  font: IMedia;
}

export const Font: React.FC<IFontProps> = ({ font }) => {
  const [isPopoverOpen, setIsPopoverOpen] = useState<boolean>(false);
  const [isEditView, setIsEditView] = useState<boolean>(false);
  const [fontName, setFontName] = useState<string>(font.display_name ?? '');

  const [, actions] = useBrandKitState();

  const handleFontNameChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ): void => {
    setFontName(e.target.value);
  };

  const handleEditFontName = async (): Promise<void> => {
    await actions.setFontName(fontName, font.uuid);
    setIsEditView(false);
    setIsPopoverOpen(false);
  };

  const handleRemoveMedia = (): void => {
    actions.removeMedia(font.uuid);
  };

  return (
    <FontItem>
      <FontNameContainer>
        {isEditView ? (
          <Input value={fontName} onChange={handleFontNameChange} />
        ) : (
          <Typography noWrap variant="Paragraph">{font.display_name}</Typography>
        )}
      </FontNameContainer>
      <Popover
        isOpen={isPopoverOpen}
        position={'top'}
        align="center"
        containerStyle={{ overflow: 'visible' }}
        onClickOutside={(): void | null =>
          isEditView ? null : setIsPopoverOpen(false)
        }
        content={({ position, targetRect, popoverRect }): ReactElement => (
          <ArrowContainer
            position={position}
            targetRect={targetRect}
            popoverRect={popoverRect}
            arrowColor={'#fff'}
            arrowSize={10}
          >
            <PopoverContainer>
              <Button
                appearance="popover"
                fontSize={12}
                height={34}
                width={80}
                uppercase={false}
                onClick={(): void | Promise<void> =>
                  isEditView ? handleEditFontName() : setIsEditView(true)
                }
              >
                <Typography
                  variant="Paragraph"
                  align="center"
                  css={{ fontSize: 12 }}
                  customColor={{ light: '#000', dark: '#9c9c9c' }}
                >
                  {isEditView ? 'Save' : 'Rename'}
                </Typography>
              </Button>
              <Divider />
              <Button
                appearance="popover"
                height={34}
                width={80}
                fontSize={12}
                uppercase={false}
                onClick={(): void =>
                  isEditView ? setIsEditView(false) : handleRemoveMedia()
                }
              >
                <Typography
                  variant="Paragraph"
                  align="center"
                  css={{ fontSize: 12 }}
                  customColor={{ light: '#000', dark: '#9c9c9c' }}
                >
                  {isEditView ? 'Cancel' : 'Remove'}
                </Typography>
              </Button>
            </PopoverContainer>
          </ArrowContainer>
        )}
      >
        <Button
          appearance="subtle"
          iconBefore={<OptionsMenuIcon />}
          onClick={(): void => setIsPopoverOpen(!isPopoverOpen)}
        ></Button>
      </Popover>
    </FontItem>
  );
};
